<template>
  <div v-if="selectedReference" class="sidepanel">
    <SidepanelHeader icon="slides" :title="panelTitle" />
    <DocumentContainer  />
  </div>
  <DocumentSkeletonLoader v-else />
</template>

<script>
import { computed } from 'vue';
import useModals from '~/composables/useModals';
import useDocuments from '~/composables/useDocuments';
import DocumentContainer from '~/components/conversation/DocumentContainer';
import DocumentSkeletonLoader from '~/components/conversation/documentPanel/DocumentSkeletonLoader';
import SidepanelHeader from '~/components/conversation/sidepanelGeneralComponents/SidepanelHeader.vue';

export default {
  components: { DocumentContainer, DocumentSkeletonLoader, SidepanelHeader },
  setup() {
    const { setCurrentDocumentsDialog } = useModals();
    const { selectedReference } = useDocuments();

    const panelTitle = computed(() => {
      const { name, type } = selectedReference.value || {};
      if (name) return name;
      return type === 'userGeneratedImage' ? 'User Generated Image' : 'Document';
    });

    const onClose = () => {
      setCurrentDocumentsDialog(null);
    };

    return {
      selectedReference,
      panelTitle,
      onClose,
    };
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

// need to make the container scrollable when viewport height smaller
@media (max-height: 750px) {
  .sidepanel {
    overflow: auto;
  }
}

.sidepanel {
  @include media-breakpoint-up('sm') {
    display: flex;
    overflow: hidden;
  }

  max-height: calc(100vh - 80px);

  // take into consideration the margins
  height: 100%;
  display: none;
  flex-direction: column;
  background-color: $bb-neutral-0;
  border-radius: $bb-spacing-8;
  border: 1px solid #cecdcb;
  box-shadow: 0 0 $bb-spacing-2 0 #0000001a;
  align-items: center;
  min-width: 476px;
  max-width: 476px;
}
</style>
